<template>
  <div class="checkout-step-container">
    <div class="shipping__address">
      <h2>{{ $t('Shipping address') }}</h2>
      <div class="block__holder">
        <checkout-address-login v-if="!isLoggedIn"></checkout-address-login>
        <div class="field__group --newsletter" v-if="!isLoggedIn">
          <input type="checkbox" name="newsletter" id="newsletter" v-model="newsletter" />
          <label for="newsletter">{{ $t('Sign up for the newsletter') }}</label>
        </div>
        <checkout-address-shipping
          :addresses="addresses"
          :is-logged-in="isLoggedIn"
          :is-business-account="isBusinessAccount"
        ></checkout-address-shipping>
      </div>
      <div class="billing-same-as-shipping-control">
        <input id="billingIsSameAsShipping" type="checkbox" @change="toggleBillingIsSameAsShipping" :value="!billingIsSameAsShipping"/>
        <label for="billingIsSameAsShipping"><span>{{ $t('Billing address is different from the address above') }}</span></label>
      </div>
    </div>
    <div class="billing__address" v-if="!billingIsSameAsShipping">
      <h2>{{ $t('Billing address') }}</h2>
      <div class="block__holder">
        <checkout-address-billing
          :addresses="addresses"
          :is-logged-in="isLoggedIn"
          :is-business-account="isBusinessAccount"
        ></checkout-address-billing>
      </div>
    </div>
  </div>
</template>

<script lang="ts">
  import {Component, Prop, Vue} from 'vue-property-decorator';
  import ServiceContainer from '@flashpointbv/solar-service-container';

  @Component({
    name: 'checkout-address-detail',
    components: {
      'checkout-address-shipping': ServiceContainer().getComponent('checkout-address-shipping'),
      'checkout-address-billing': ServiceContainer().getComponent('checkout-address-billing'),
      'checkout-address-login': ServiceContainer().getComponent('checkout-address-login')
    }
  })

  export default class extends Vue {
    @Prop({ required: false, default: false }) private isLoggedIn: boolean;
    @Prop({ required: false, default: false }) private isBusinessAccount: boolean;
    @Prop({ required: false, default: [] }) private addresses: Array<object>;

    private get billingIsSameAsShipping() {
      return this.$store.getters['CheckoutAddress/billingIsSameAsShipping'];
    }

    private get newsletter(): boolean {
      return this.$store.state['CheckoutGlobal']['newsletterSubscribe'];
    }

    private set newsletter(value) {
      this.$store.dispatch('CheckoutGlobal/setNewsletterSubscribe', value);
    }

    private toggleBillingIsSameAsShipping() {
      this.$store.dispatch('CheckoutAddress/toggleBillingIsSameAsShipping');
    }

    private created(): void {
      // Ensure extension attribute mirrors current newsletter preference.
      this.$store.dispatch('CheckoutGlobal/setNewsletterSubscribe', this.newsletter);
    }
  }
</script>
